import { Box, Image, Text, useWindowDimensions } from '@jfs/ui-new'
import { staticStrings } from '../../static/staticStrings'
import { isMobileWidth } from '../../util/util'
import { UserNeedTiles } from './UserNeedTiles'

export const JioPayForBharat = () => {
  const viewportWidth = useWindowDimensions()
  const isMobile = isMobileWidth(viewportWidth)
  return (
    <Box alignItems={'center'} pv={104} pl={isMobile ? undefined : 80}>
      <Image
        source={require('../../assets/images/india-map.png')}
        width={isMobile ? 280 : 500}
        height={isMobile ? 308 : 550}
      />
      {isMobile && (
        <Box marginTop={32} align={'center'} justify={'center'}>
          <Image source={require('../../assets/svg/bharathpay-tiles.svg')} width={258} height={248} />
        </Box>
      )}
      {!isMobile && <UserNeedTiles />}
      <Box position={'absolute'} top={isMobile ? 200 : '33vh'} justify={'center'} marginRight={isMobile ? '20%' : 100}>
        <Text fontFamily={'jiotype-black'} fontSize={isMobile ? 14 : 24} lineHeight={isMobile ? 16 : 26}>
          {'    JioPay'}
          <Text
            fontSize={isMobile ? 16 : 32}
            fontFamily={'jiotype-black'}
            letterSpacing={-0.6}
            lineHeight={isMobile ? 18 : 28}>
            {staticStrings.builtForBharat}
          </Text>
          {'    needs'}
        </Text>
      </Box>
    </Box>
  )
}
